import { createContext } from 'react'

export const reducerContext = createContext()